export function createEmptyTopic(parentId = null) {
  return {
    id: `topic-${Date.now()}`,
    parentId,
    title: "",
  };
}

export function getTopicChildren(topics, parentId = null) {
  const normalizedParent = parentId ?? null;
  return (topics ?? []).filter(
    (topic) => (topic.parentId ?? null) === normalizedParent,
  );
}

export function topicHasChildren(topics, topicId) {
  return getTopicChildren(topics, topicId).length > 0;
}

export function collectTopicDescendantIds(topics, topicId) {
  const ids = new Set([topicId]);
  const walk = (parentId) => {
    getTopicChildren(topics, parentId).forEach((child) => {
      ids.add(child.id);
      walk(child.id);
    });
  };
  walk(topicId);
  return ids;
}

export function getRootTopics(topics) {
  return getTopicChildren(topics, null);
}

export function getTopicRootId(topics, topicId) {
  const path = getTopicPath(topics, topicId);
  return path[0]?.id ?? topicId ?? null;
}

export function readPersistedKbTopics(game) {
  const rawTopics = Array.isArray(game?.kbTopics) ? game.kbTopics : [];
  return rawTopics.map((topic) => ({
    id: String(topic.id),
    parentId: topic.parentId ?? null,
    title: String(topic.title ?? "").trim(),
  }));
}

export function getTopicPath(topics, topicId) {
  const path = [];
  let currentId = topicId;
  while (currentId) {
    const lookupId = currentId;
    const current = topics.find((topic) => topic.id === lookupId);
    if (!current) break;
    path.unshift(current);
    currentId = current.parentId ?? null;
  }
  return path;
}

export function getTopicDepth(topics, topicId) {
  const path = getTopicPath(topics, topicId);
  return path.length;
}

export function isRootTopic(topics, topicId) {
  const topic = topics.find((entry) => entry.id === topicId);
  return Boolean(topic && (topic.parentId ?? null) === null);
}

export function isSubtopic(topics, topicId) {
  return getTopicDepth(topics, topicId) === 2;
}

export function canAddSubtopic(topics, topicId) {
  if (!topicId) return false;
  return isRootTopic(topics, topicId);
}

export function canHaveQuestions() {
  return true;
}

export function getTopicKindLabel(topics, topicId) {
  if (!topicId) return "раздел";
  return isRootTopic(topics, topicId) ? "тема" : "подтема";
}

export function normalizeKbData(game) {
  const rawTopics = Array.isArray(game?.kbTopics) ? game.kbTopics : [];
  let topics = rawTopics.map((topic) => ({
    id: String(topic.id),
    parentId: topic.parentId ?? null,
    title: String(topic.title ?? "").trim(),
  }));

  let items = (game?.kbItems ?? []).map((item) => ({
    ...item,
    topicId: item.topicId ?? null,
  }));

  topics = topics.filter((topic) => {
    if (!String(topic.id).startsWith("topic-root-")) return true;
    return items.some((item) => item.topicId === topic.id);
  });

  if (!topics.length && items.length > 0) {
    const legacyTitle = (game?.kbTheme || "").trim();
    const rootId = `topic-root-${game?._id ?? "legacy"}`;
    topics = [{ id: rootId, parentId: null, title: legacyTitle || "Общее" }];
    items = items.map((item) => ({
      ...item,
      topicId: item.topicId || rootId,
    }));
  }

  return { topics, items };
}
